import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/contact";

export default function WhatsAppFab() {
  return (
    <a data-testid="whatsapp-fab" href={waLink("")} target="_blank" rel="noreferrer" aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-40 h-14 w-14 flex items-center justify-center bg-vorna-accent hover:bg-vorna-accentHover rounded-full shadow-lg shadow-black/50 active:scale-95 transition-all">
      <MessageCircle className="h-7 w-7" />
      <span className="absolute inset-0 rounded-full bg-vorna-accent animate-ping opacity-20" />
    </a>
  );
}
